import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { CantonDefault, Canton } from "@/types/insurance";

export const useCantonDefaults = (canton?: Canton) => {
  return useQuery({
    queryKey: ['canton-defaults', canton],
    queryFn: async (): Promise<CantonDefault[]> => {
      let query = supabase
        .from('canton_defaults')
        .select(`
          *,
          swiss_insurance_types!inner (
            code,
            name_german,
            name_english,
            category
          )
        `)
        .order('swiss_insurance_types.category', { ascending: true });

      if (canton) {
        query = query.eq('canton_code', canton);
      }

      const { data, error } = await query;

      if (error) {
        throw error;
      }

      return data || [];
    },
    enabled: !!canton
  });
};